// extracted by mini-css-extract-plugin
export default {"container":"FloorHeader_container__EZB1E","floor":"FloorHeader_floor__Jtemj","desc":"FloorHeader_desc__hz0KK"};